export const Portfolio = ()=>{
    return(
        <>
             <div id="dgid" className="our-services section">
  

<div className="container">
      <div className="row">
       
        
        <div className="col-lg-6 align-self-center  wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">
          <div className="left-image">
            <img src="assets/images/rosly.png" width="350em" height="350em" alt="" />
          </div>
        </div>

        <div className="col-lg-6 wow fadeInRight" data-wow-duration="1s" data-wow-delay="0.2s">
          <div className="section-heading">
          <h2 className="text-center">LA <em style={{color:"#03A4ED"}}>DGID</em></h2><br/>
            <h4 style={{fontWeight:"normal"}}>La Direction Générale des Impôts et des Domaines (DGID) soutient activement notre plateforme de paiement en ligne. Grâce à cette collaboration, nous pouvons offrir une solution pratique aux contribuables, permettant de payer rapidement et en toute sécurité leurs impôts et pénalités, tout en contribuant au développement du pays.</h4>
          </div>
          
         
        </div>
       
      </div>
      <br/><br/><br/>
    </div>
  </div>
        </>
    )
}